// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#flotTip{padding:3px 5px;background-color:#000;z-index:100;color:#fff;opacity:.8;filter:alpha(opacity=85)}", ""]);
// Exports
module.exports = exports;
